/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { User_user_read_post_read } from '../models/User_user_read_post_read';
import type { User_user_write } from '../models/User_user_write';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserService {
    /**
     * Retrieves a User resource.
     * Retrieves a User resource.
     * @param id User identifier
     * @returns User_user_read_post_read User resource
     * @throws ApiError
     */
    public static userActivateGet(
        id: string,
    ): CancelablePromise<User_user_read_post_read> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/activate/{token}',
            path: {
                'id': id,
            },
            errors: {
                404: `Resource not found`,
            },
        });
    }
    /**
     * Creates a User resource.
     * Creates a User resource.
     * @param requestBody The new User resource
     * @returns User_user_read_post_read User resource created
     * @throws ApiError
     */
    public static userRegister(
        requestBody: User_user_write,
    ): CancelablePromise<User_user_read_post_read> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/register',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input`,
                422: `Unprocessable entity`,
            },
        });
    }
    /**
     * Retrieves the collection of User resources.
     * Retrieves the collection of User resources.
     * @param page The collection page number
     * @returns User_user_read_post_read User collection
     * @throws ApiError
     */
    public static apiV1UsersGetCollection(
        page: number = 1,
    ): CancelablePromise<Array<User_user_read_post_read>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/users',
            query: {
                'page': page,
            },
            errors: {
                403: `Forbidden`,
            },
        });
    }
    /**
     * Retrieves a User resource.
     * Retrieves a User resource.
     * @param id User identifier
     * @returns User_user_read_post_read User resource
     * @throws ApiError
     */
    public static apiV1UsersIdGet(
        id: string,
    ): CancelablePromise<User_user_read_post_read> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/users/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * Removes the User resource.
     * Removes the User resource.
     * @param id User identifier
     * @returns void
     * @throws ApiError
     */
    public static apiV1UsersIdDelete(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/users/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * Updates the User resource.
     * Updates the User resource.
     * @param id User identifier
     * @param requestBody The updated User resource
     * @returns User_user_read_post_read User resource updated
     * @throws ApiError
     */
    public static apiV1UsersIdPatch(
        id: string,
        requestBody: User_user_write,
    ): CancelablePromise<User_user_read_post_read> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/users/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/merge-patch+json',
            errors: {
                400: `Invalid input`,
                403: `Forbidden`,
                404: `Resource not found`,
                422: `Unprocessable entity`,
            },
        });
    }
}
